import { Injectable, inject } from '@angular/core';
import { PlatformService } from './platform-service.service';

@Injectable({
  providedIn: 'root',
})
export class ImagePreloadService {
  private readonly cache = new Map<string, Promise<string>>();

  private readonly platformService = inject(PlatformService);

  preloadImage(url: string): Promise<string> {
    return this.platformService.run({
      browser: () => {
        // If already cached, return the existing promise
        if (this.cache.has(url)) {
          return this.cache.get(url)!;
        }

        // Create a new promise to preload the image
        const imagePromise = new Promise<string>((resolve, reject) => {
          const img = new Image();
          img.src = url;

          img.onload = () => resolve(url); // Resolve with URL once loaded
          img.onerror = reject; // Handle errors
        });

        // Store the promise in the cache
        this.cache.set(url, imagePromise);

        return imagePromise;
      },
      server: () => Promise.resolve(url),
    });
  }
}
